import { ActivityReferencePadProvider } from './ActivityReferencePadProvider';

export const ActivitiesReferenceContextPadModule = {
    __init__: ['referenceActivityPadProvider'],
    referenceActivityPadProvider: ['type', ActivityReferencePadProvider],
};
